<template>
    <div>
      <law-matter-evidence-detection-counter-party-form 
      :getLawMatterEvidenceDetectionCounterPartyList="getLawMatterEvidenceDetectionCounterPartyList" ref="lawMatterEvidenceDetectionCounterPartyFormModal" 
      :lawMatterEvidenceDetectionId="lawMatterEvidenceDetectionId"></law-matter-evidence-detection-counter-party-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:left;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search')" type="text"
                  class="d-inline-block" />
              </div>
            </b-form-group>
          </div>
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right;" size="sm"  variant="outline-primary" @click="getInfo(0)">{{ $t('matterNote.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="lawMatterEvidenceDetectionCounterPartyTable"
      ref="lawMatterEvidenceDetectionCounterPartyTable" 
      :columns="columns" 
      :rows="rows" 
      styleClass="vgt-table condensed tableSize" 
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, 
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, 
        selectAllByGroup: true,
      }" 
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'lawCounterPartyName'" class="text-nowrap">
            {{ $t('lawMatterEvidenceDetectionCounterParty.counter_party') }}
          </span>
          <span v-if="props.column.field === 'lawCounterPartyAttorneyName'" class="text-nowrap">
            {{ $t('lawMatterEvidenceDetectionCounterParty.counter_party_attorney') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary"
                    class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                    <feather-icon icon="EditIcon" />
                </b-button>
                <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                    size="sm" @click="deleted(props.row)">
                    <feather-icon icon="XIcon" />
                </b-button>
                </span>
            </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
              </span>
              <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      lawMatterEvidenceDetectionId: {type: Number}
    },
    data() {
      return {
        pageLength: 10,
        dir: false,
        columns: [
          {
            label: this.$t('lawMatterEvidenceDetectionCounterParty.counter_party'),
            field: `lawCounterPartyName`,
          },
          {
            label: this.$t('lawMatterEvidenceDetectionCounterParty.counter_party_attorney'),
            field: `lawCounterPartyAttorneyName`,
          },
          {
            label: 'Process',
            field: 'process',
            width: '10em'
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getLawMatterEvidenceDetectionCounterPartyList()
    },
    methods: {
      async deleted(row) {
       
        const data = { id: row.id }
        const controller = { name: 'LawMatterEvidenceDetectionCounterParty' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getLawMatterEvidenceDetectionCounterPartyList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getLawMatterEvidenceDetectionCounterPartyList()
              }
            })
          }
        })
      },
      async getInfo(id) {
        this.$refs.lawMatterEvidenceDetectionCounterPartyFormModal.showInfo(id)
      },
      getLawMatterEvidenceDetectionCounterPartyList() {
        this.rows = []
            const data = {
                id: this.lawMatterEvidenceDetectionId
            }
            const controller = {
                name: 'LawMatterEvidenceDetectionCounterParty',
                actionName: 'GetLawMatterEvidenceDetectionCounterPartyListByLawMatterEvidenceDetectionId'
            }
            const payload = {
                controller: controller,
                data: data
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.lawMatterEvidenceDetectionCounterPartyList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
      },
    },
  }
  </script>
  <style lang="scss" >
  .tableSize {
    font-size: 13px!important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
  }
  </style>
  